/* eslint-disable */

import { createStore }  from "vuex";

import VuexPersist      from "vuex-persist";

import auth     from "./auth";
import locales  from "./locales";
import setup    from "./setup";
import users    from "./users";

const vuexLocalStorage = new VuexPersist({
    storage: window.localStorage
});

export default createStore({

    plugins: [
        vuexLocalStorage.plugin
    ],

    modules: {

        auth,
        locales,
        setup,
        users
    }

});